import { FC, useState } from "react";

import ModalItemPreview from "./ModalItemPreview";
import { IUploadFile } from "./interface";
import { downloadFileFromServerByUrl } from "../../api/helpers";
import { FileMimeTypes } from "../../api/Types";
import { getFileMimeType } from "../../api/Files";

import {
  DownloadPdfIco,
  ExcelIco,
  InfoIco,
  PaperIco,
  PdfIco,
  QuestionMarkDocIco,
  ReportIco,
  WordIco,
  DeleteFileIco,
} from "../../assets/customIcons";
import styles from "./UploadFile.module.scss";
import classNames from "classnames";

interface IItemPreview {
  file: IUploadFile;
}

const ItemPreview: FC<IItemPreview> = ({ file }) => {
  const [showModal, setShowModal] = useState(false);
  const { type, contentType, name, originalName, error } = file;

  const downloadFile = () => {
    downloadFileFromServerByUrl(file.thumbUrl, name || originalName);
  };

  const smallItemPreview = () => {
    if (error) {
      return (
        <PaperIco
          className={classNames(styles.uploadPreviewIco, {
            [styles.uploadError]: error,
          })}
          onClick={downloadFile}
        />
      );
    }
    const fileType = getFileMimeType(type || contentType);
    switch (fileType) {
      case FileMimeTypes.img:
        return (
          <img
            src={file.thumbUrl}
            onClick={() => setShowModal(true)}
            style={{ cursor: "pointer" }}
          />
        );
      case FileMimeTypes.doc:
        return (
          <WordIco className={styles.uploadPreviewIco} onClick={downloadFile} />
        );
      case FileMimeTypes.xls:
        return (
          <ExcelIco
            className={styles.uploadPreviewIco}
            onClick={downloadFile}
          />
        );
      case FileMimeTypes.pdf:
        return (
          <PdfIco className={styles.uploadPreviewIco} onClick={downloadFile} />
        );
      default:
        return (
          <PaperIco
            className={styles.uploadPreviewIco}
            onClick={downloadFile}
          />
        );
    }
  };

  return (
    <>
      {smallItemPreview()}
      <ModalItemPreview
        isShow={showModal}
        handleCancel={() => setShowModal(false)}
        file={file}
      />
    </>
  );
};

export default ItemPreview;
